import React from "react";

import Meta from "../components/Meta";
import HeaderSection from "../components/header/HeaderSection";

const Page = () => {

  return (
    <>
      <Meta title="The Engineering Book Club Podcast" desc="A Podcast run by Jose A Lobato and Miguel Ángel Martin where we discuss books that we are reading in the book club."/>
      <HeaderSection title="Podcast" subtitle="A Podcast where we discuss books that we are reading inside the community"/>

      <section className="relative py-5">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <div className="lg:flex lg:justify-between py-10">
            {/* <!-- Image --> */}
            <div className="lg:w-[55%]">
              <div className="relative">
                <img
                  src="/images/will-francis-ZDNyhmgkZlQ-unsplash.jpg"
                  width="200"
                  height="200"
                  className="mx-auto w-[100%] rounded-[3rem]"
                />
              </div>
            </div>

            {/* <!-- Info --> */}
            <div className="py-20 lg:w-[45%] lg:pl-16">
              <p className="dark:text-jacarta-60 mb-8 text-lg leading-normal">
                Find us on your favourite podcast platform
              </p>
              <p className="dark:text-jacarta-60 mb-8 leading-normal">
                This is the podcast where we discuss the books that we are reading inside the community. We share our thoughts, insights, and key takeaways from each book.
              </p>
              
              <p>
                <a className="float-left mr-3.5" href="https://podcasts.apple.com/us/channel/engineering-book-club/id6746479206"><img src="/images/apple-podcast.png" alt="Apple Podcast Link" width="30px" height="30px"/></a>
                <a className="float-left mr-3.5" href="#"><img src="/images/spotify.png" alt="Spotify Podcast Link" width="30px" height="30px"/></a>
                {/*<a className="float-left mr-3.5" href="#"><img src="/images/ivox.png" alt="Ivox Podcast Link" width="30px" height="30px"/></a>*/}
                <a className="float-left mr-3.5" href="https://www.youtube.com/@EngineeringBookClub"><img src="/images/youtube.png" alt="Youtube  Podcast Link" width="30px" height="30px"/></a>
              </p>

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Page;
